'use client';

import React from 'react';

interface ColorInfo {
  id: string;
  mfrCode: string;
  genericColor: string;
  mfrColor: string;
  hex: string;
  r: string;
  g: string;
  b: string;
  twoTone?: string;
  fleet?: string;
  secondaryHex?: string;
  secondaryR?: string;
  secondaryG?: string;
  secondaryB?: string;
}

interface ColorsSectionProps {
  exterior: ColorInfo[];
  interior: ColorInfo[];
}

const ColorsSection: React.FC<ColorsSectionProps> = ({ exterior, interior }) => {
  const renderColors = (colors: ColorInfo[]) => {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {colors.map((color) => (
          <div key={color.id} className="flex gap-4 p-3 border rounded items-start">
            <div className="flex flex-col gap-1 items-center">
              {/* Primary swatch */}
              <div
                className="w-10 h-10 rounded-full border"
                style={{ backgroundColor: `#${color.hex}` }}
              ></div>
              {/* Secondary swatch if available */}
              {color.secondaryHex && (
                <div
                  className="w-6 h-6 rounded-full border"
                  style={{ backgroundColor: `#${color.secondaryHex}` }}
                  title="Secondary Color"
                ></div>
              )}
            </div>

            <div>
              <p className="font-semibold">{color.mfrColor}</p>
              <p className="text-sm text-gray-600">{color.genericColor}</p>
              <p className="text-xs text-gray-500">MFR Code: {color.mfrCode}</p>
              <p className="text-xs text-gray-500">Fleet: {color.fleet}</p>
              <p className="text-xs text-gray-500">Two Tone: {color.twoTone}</p>

              <p className="text-xs text-gray-500 mt-1">Primary Hex: {color.hex}</p>
              <p className="text-xs text-gray-500">
                RGB: {color.r}, {color.g}, {color.b}
              </p>

              {color.secondaryHex && (
                <>
                  <p className="text-xs text-gray-500 mt-1">Secondary Hex: {color.secondaryHex}</p>
                  <p className="text-xs text-gray-500">
                    Secondary RGB: {color.secondaryR}, {color.secondaryG}, {color.secondaryB}
                  </p>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Colors</h2>

      {exterior.length > 0 && (
        <div>
          <h3 className="font-medium mb-2">Exterior Colors</h3>
          {renderColors(exterior)}
        </div>
      )}

      {interior.length > 0 && (
        <div>
          <h3 className="font-medium mt-4 mb-2">Interior Colors</h3>
          {renderColors(interior)}
        </div>
      )}

      {exterior.length === 0 && interior.length === 0 && (
        <p className="text-gray-500">No color information available.</p>
      )}
    </div>
  );
};

export default ColorsSection;
